import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Reporting extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M22,20H4c-0.6,0-1-0.4-1-1V3c0-0.6-0.4-1-1-1H1C0.4,2,0,2.4,0,3
                v19c0,0.6,0.4,1,1,1h21c0.6,0,1-0.4,1-1v-1C23,20.4,22.6,20,22,20z"
                />
                <path
                    d="M6,18h2c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1H6c-0.6,0-1,0.4-1,1v4
                C5,17.6,5.4,18,6,18z"
                />
                <path
                    d="M12,18h2c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1
                v7C11,17.6,11.4,18,12,18z"
                />
                <path
                    d="M18,18h2c0.6,0,1-0.4,1-1V5c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1
                v12C17,17.6,17.4,18,18,18z"
                />
            </SvgIcon>
        );
    }
}

export default Reporting;
